import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCameraIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 26,
			cy: 26,
			r: 26,
			transform: "rotate(90 26 26)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 20.7602V31.2402C16 34.0002 17.69 35.1002 19.75 35.2302L28.01 35.7502C30.17 35.8902 32 34.1702 32 32.0002C32 31.3902 32.35 30.8302 32.89 30.5502L34.34 29.8302C35.25 29.3702 36 28.1702 36 27.1502V24.8602C36 23.8302 35.25 22.6302 34.34 22.1702L32.89 21.4502C32.35 21.1702 32 20.6102 32 20.0002C32 17.8302 30.17 16.1102 28.01 16.2502L19.75 16.7702C17.69 16.8902 16 18.0002 16 20.7602Z",
			stroke: "#787878",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 24.5V27.5",
			stroke: "#787878",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 26C20 27.79 21.46 29.25 23.25 29.25C25.04 29.25 26.5 27.79 26.5 26C26.5 24.21 25.04 22.75 23.25 22.75C21.46 22.75 20 24.21 20 26Z",
			stroke: "#787878",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCameraIcon;
